(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enkei-newsletter-review"]) return;
  try {
    
if (!customElements.get('enkei-newsletter')) {
  customElements.define('enkei-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.buttonLabel = this.submitButton.textContent;
      this.storageKey = 'enkei-newsletter-dismissed';
      document.addEventListener('click', event => {
        if (event.target.closest('[data-enkei-newsletter-open]')) {
          event.preventDefault();
          this.open();
        }
      }, { signal });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => this.remember(), { signal });
      this.form.addEventListener('submit', event => this.subscribe(event), { signal });
      if (this.dataset.auto === 'true') {
        let dismissed = 0;
        try { dismissed = Number(localStorage.getItem(this.storageKey) || 0); } catch (error) {}
        if (Date.now() - dismissed > 604800000) {
          const showWhenReady = () => {
            if (!this.isConnected) return;
            const consentBanner = document.querySelector('#shopify-pc__banner');
            if (consentBanner && consentBanner.getBoundingClientRect().height) {
              this.timer = setTimeout(showWhenReady, 2000);
              return;
            }
            this.open();
          };
          this.timer = setTimeout(showWhenReady, 8000);
        }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller.abort();
    }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }
    remember() {
      try { localStorage.setItem(this.storageKey, String(Date.now())); } catch (error) {}
    }
    async subscribe(event) {
      event.preventDefault();
      if (!this.form.reportValidity() || this.submitButton.disabled) return;
      const email = this.form.elements.email.value.trim();
      const body = { data: { type: 'subscription', attributes: { custom_source: 'Enkei website newsletter', profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: this.dataset.list } } } } };
      this.submitButton.disabled = true;
      this.submitButton.textContent = this.dataset.pending;
      this.status.textContent = '';
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.dataset.company), { method: 'POST', credentials: 'omit', headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-10-15' }, body: JSON.stringify(body), signal: AbortSignal.timeout(15000) });
        if (response.status !== 202) throw new Error('Subscription unavailable');
        this.form.hidden = true;
        this.status.textContent = this.dataset.success;
        this.remember();
      } catch (error) {
        this.status.textContent = this.dataset.error;
      } finally {
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.buttonLabel;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
